import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {GrowthbookService} from "./services/growthbook.service";
import {filter} from "rxjs";
import { ToastContainerComponent } from './components/layout/toast-container/toast-container.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ToastContainerComponent],
    templateUrl: './app.html',
    styleUrl: './app.css'
})
export class App implements OnInit {
    constructor(private router: Router,
                private gb: GrowthbookService) {
    }

    ngOnInit() {
        // SPA: notify GrowthBook on every route change
        this.router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe(() => {
                if (typeof window !== 'undefined') {
                    this.gb.setUrl(window.location.href);
                }
            });
    }
}
